import React, { useEffect, useState, useRef } from 'react';
import './App.scss';
import { csv } from "d3";
import DatavisController from './components/controller/Controller';
import ChartWrapper1 from './components/charts/ChartWrapper';
import MiniDash from './components/minidash/MiniDash';
import csvdata from './data.csv'
import DataContext from './contexts/DataContext';
import FirstIndustryContext from './contexts/FirstIndustryContext';
import SecondIndustryContext from './contexts/SecondIndustryContext';


function App() {
  const datavisWrapperRef = useRef();
  const [data, setData] = useState({});
  const [isMobileSize, setIsMobile] = useState();
  const [volume, setVolume] = useState({});
  const [firstIndustry, setFirstIndustry] = useState("1. Courier Service");
  const [secondIndustry, setSecondIndustry] = useState("20. Food & Beverage");
  const [firstIndustryData, setFirstIndustryData] = useState(null)
  const [secondIndustryData, setSecondIndustryData] = useState(null)

  useEffect(() => {
    if (datavisWrapperRef.current.clientWidth < 780) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [])

  useEffect(() => {
    function handleResize() {
      if (datavisWrapperRef.current.clientWidth < 780) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    window.addEventListener('resize', handleResize)
    // return _ => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    let masterData = {};
    let volumeData = {}
    csv(csvdata).then(function (_data) {
      _data.forEach(d => {
        masterData[d["Industry"]] = [
          { "rank": 1, "axis": d["axis-1"], "value": 1, "volume": +d["value-1"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 2, "axis": d["axis-2"], "value": 2, "volume": +d["value-2"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 3, "axis": d["axis-3"], "value": 3, "volume": +d["value-3"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 4, "axis": d["axis-4"], "value": 4, "volume": +d["value-4"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 5, "axis": d["axis-5"], "value": 5, "volume": +d["value-5"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 6, "axis": d["axis-6"], "value": 6, "volume": +d["value-6"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 7, "axis": d["axis-7"], "value": 8, "volume": +d["value-7"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 8, "axis": d["axis-8"], "value": 8, "volume": +d["value-8"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 9, "axis": d["axis-9"], "value": 9, "volume": +d["value-9"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) },
          { "rank": 10, "axis": d["axis-10"], "value": 10, "volume": +d["value-10"].replace(",", ""), "totalVolume": parseInt(d["Total Number of Transactions"].replace(",", "")) }
        ]
        volumeData[d["Industry"]] = d["Total Number of Transactions"]
      })
      setVolume(volumeData)
      setData(masterData);
    })
  }, [])



  useEffect(() => {
    if (data[firstIndustry] && data[secondIndustry]) {

      // sort data into alphabetical order
      let _data1 = data[firstIndustry].sort(function (a, b) {
        if (a.axis < b.axis) {
          return -1;
        } else if (a.axis > b.axis) {
          return 1;
        } else {
          return 0;
        }
      });
      let _data2 = data[secondIndustry].sort(function (a, b) {
        if (a.axis < b.axis) {
          return -1;
        } else if (a.axis > b.axis) {
          return 1;
        } else {
          return 0;
        }
      });

      // swap value for data1
      let _data1p1 = []
      let _data1p2 = []
      _data1.forEach(d => {
        if (Array.from(_data2.map(d => d.axis)).includes(d.axis)) {
          _data1p1.push(d)
        } else {
          _data1p2.push(d);
        }
      })
      let __data1 = [..._data1p1, ..._data1p2];

      // swap value for data2
      let _data2p1 = []
      let _data2p2 = []
      _data2.forEach(d => {
        if (Array.from(_data1.map(d => d.axis)).includes(d.axis)) {
          _data2p1.push(d)
        } else {
          _data2p2.push(d);
        }
      })
      let __data2 = [..._data2p1, ..._data2p2];


      setFirstIndustryData([...__data1])
      setSecondIndustryData([...__data2])
      // // swap value for data 2
    }
  }, [data, firstIndustry, secondIndustry]);
  


  return (
    <div className="App">
      <div ref={datavisWrapperRef} className="datavis-wrapper">
        {/* <div className="datavis-header" >
          <h1 style={isMobile ? { fontSize: '2em' } : {fontSize:'4em'}}><span>How do you stack up?</span> <span>Compare your expenses to your peers</span></h1>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        </div> */}
        <DataContext.Provider value={data}>
          <FirstIndustryContext.Provider value={{ ind: firstIndustry, setInd: setFirstIndustry }}>
            <SecondIndustryContext.Provider value={{ ind: secondIndustry, setInd: setSecondIndustry }}>
              <DatavisController isMobile={isMobileSize}></DatavisController>
              <div className="chart-container chart-container__first">
                <ChartWrapper1 data={firstIndustryData}
                  colour="#f5894e"
                  ind={firstIndustry}
                  volume={volume[firstIndustry]}
                  chartId={1}
                  isMobile={isMobileSize}
                />
              </div>
              <MiniDash isMobile={isMobileSize} ind1={firstIndustry} volume1={volume[firstIndustry]} ind2={secondIndustry} volume2={volume[secondIndustry]}></MiniDash>
              <ChartWrapper1 data={secondIndustryData}
                colour="#f5894e"
                ind={secondIndustry}
                volume={volume[secondIndustry]}
                chartId={2}
                isMobile={isMobileSize}
              />
            </SecondIndustryContext.Provider>
          </FirstIndustryContext.Provider>
        </DataContext.Provider>
      </div>

    </div >

  );
}

export default App;
